import { useEffect, useState } from "react";
import api from "../lib/api";
import { fmtUSD, fmtDate } from "../lib/format";
import { PageHeader, StatusBadge } from "../components/PageHeader";
import { DataTable } from "../components/DataTable";
import { Loader } from "../components/KpiCard";

const ORDER = ["Current", "1-30 days", "31-60 days", "61-90 days", "90+ days"];
const bucketTone = (b) => ({ Current: "blue", "1-30 days": "amber", "31-60 days": "amber", "61-90 days": "red", "90+ days": "red" }[b] || "gray");

export default function Payables() {
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/reports/ap-aging").then((r) => setData(r.data)); }, []);
  if (!data) return <Loader />;

  const cols = [
    { key: "vendor", label: "Vendor", className: "font-medium" },
    { key: "description", label: "Description", className: "text-[#5C5C54]" },
    { key: "invoice_number", label: "Invoice", className: "font-mono text-xs text-[#5C5C54]" },
    { key: "expense_date", label: "Bill Date", render: (r) => fmtDate(r.expense_date) },
    { key: "amount", label: "Amount", align: "right", render: (r) => <span className="font-semibold">{fmtUSD(r.amount)}</span> },
    { key: "bucket", label: "Aging", render: (r) => <StatusBadge tone={bucketTone(r.bucket)}>{r.bucket}</StatusBadge> },
    { key: "approval_status", label: "Approval", render: (r) => <StatusBadge tone={r.approval_status === "Approved" ? "green" : "amber"}>{r.approval_status}</StatusBadge> },
  ];

  return (
    <div>
      <PageHeader title="Accounts Payable Aging" subtitle="Outstanding vendor bills bucketed by days overdue — drawn from unpaid expenses." />
      <div className="grid grid-cols-6 gap-4 mb-6">
        <div className="bg-forest text-white rounded-xl p-4">
          <div className="text-[11px] uppercase tracking-wide text-white/70">Total Payable</div>
          <div className="text-xl font-semibold mt-1" data-testid="ap-total">{fmtUSD(data.total)}</div>
        </div>
        {ORDER.map((b) => (
          <div key={b} className="bg-white border border-stone-200 rounded-xl p-4" data-testid={`ap-bucket-${b.replace(/[^a-z0-9]+/gi, "-")}`}>
            <div className="text-[11px] uppercase tracking-wide text-[#8A9F95]">{b}</div>
            <div className="text-lg font-semibold mt-1">{fmtUSD(data.buckets[b] || 0)}</div>
          </div>
        ))}
      </div>
      <DataTable columns={cols} rows={data.items} testid="payables-table" empty={{ title: "No outstanding payables", hint: "All vendor bills are paid." }} />
    </div>
  );
}
